import React from 'react';

const Limit = () => {
    return (
        <div>
            Limit
        </div>
    );
};

export default Limit;